// A credit adjustment can be applied to an invoice or to a debit adjustment.
// Rows in the editor reference a target by key: "FACTURA:<id>" or "AJUSTE:<id>".

const amountOf = (value) => (Number.isFinite(Number(value)) ? Number(value) : 0);

export function creditTargetKey(document) {
  if (document?.facturaId) return `FACTURA:${document.facturaId}`;
  if (document?.ajusteId) return `AJUSTE:${document.ajusteId}`;
  return null;
}

export const eligibleCreditTargets = (documents = [], currency = 'ARS') => documents.filter((document) => creditTargetKey(document)
  && amountOf(document.saldo) > 0
  && String(document.moneda || 'ARS') === String(currency || 'ARS'));

export const findCreditTarget = (documents = [], key = '') => (key
  ? documents.find((document) => creditTargetKey(document) === String(key))
  : undefined);

export const hasIncompleteCreditApplication = (applications = []) => applications.some((application) => (
  Boolean(application.documento) !== Boolean(application.importe)
  || (application.documento && amountOf(application.importe) <= 0)
));

export function toCreditApplicationPayload(applications = []) {
  return applications
    .filter((application) => application.documento && amountOf(application.importe) > 0)
    .map((application) => {
      const [kind, id] = String(application.documento).split(':');
      const importe = amountOf(application.importe);
      return kind === 'AJUSTE' ? { ajusteDebitoId: id, importe } : { facturaId: id, importe };
    });
}
